/**
 * @name setOtherSlider.js
 */
import Splide from '@splidejs/splide';

class setOtherSlider {
    constructor() {
        this.flag = document.querySelector('.other-slider.splide');
        if (!this.flag) return;

        this.splide = null;
        this.slider = this.flag;
        this.sliderItems = this.slider.querySelectorAll('.list-item');

        this.__init();
    }

    /**
     * @name __init
     */
    __init() {
        let options = {
            type: 'loop',
            pagination: false,
            gap: '5rem',
            autoplay: true,
            interval: 5000,
            pauseOnHover: true,
            autoWidth: true,
            rewind: true,
        };

        this.splide = new Splide(this.slider, options).mount();
    }
}

export default setOtherSlider;